import React, { useEffect, useState } from 'react';
import './OptInScreen.css';

interface OptInScreenProps {
  onOptIn: () => void;
}

export const OptInScreen: React.FC<OptInScreenProps> = ({ onOptIn }) => {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('Form submission started');

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      console.log('Submitting to ConvertKit');
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        console.log('Form submitted successfully');
        
        // Show success message
        const successMessage = form.querySelector('.formkit-alert.formkit-alert-success') as HTMLElement;
        if (successMessage) {
          successMessage.textContent = 'Success! Redirecting you to RoastMyListing...';
          successMessage.style.display = 'block';
        }

        // Set localStorage
        const now = Date.now();
        localStorage.setItem('userOptIn', JSON.stringify({
          optedIn: true,
          timestamp: now
        }));

        // Wait 2 seconds then redirect
        setTimeout(() => {
          console.log('Redirecting to app');
          window.location.href = window.location.origin;
        }, 2000);
      } else {
        console.error('Form submission failed');
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      
      // Show error message
      const errorMessage = form.querySelector('.formkit-alert.formkit-alert-error') as HTMLElement;
      if (errorMessage) {
        errorMessage.textContent = 'Error submitting form. Please try again.';
        errorMessage.style.display = 'block';
      }
    }
  };


  return (
    <div className="opt-in-screen">
      <div className="left-panel">
        <div className="content">
          <h1 className="headline">Want Your Amazon Listing Roasted For Free? 🔥</h1>
          
          <h2 className="subheadline">
            Unlock The Tool That Turns Mediocre Listings Into Money Machines
          </h2>

          <div className="body-copy">
            <p>Look, we could let you in without asking for your email.</p>

            <p>But then how would we send you:</p>
            <ul className="benefits-list">
              <li>Exclusive Amazon optimization secrets</li>
              <li>New AI tools before they go public</li>
              <li>Breaking Amazon news and updates as soon as they're announced</li>
            </ul>

            <p>This isn't some BS newsletter filled with fluff. This is the no-BS Amazon intel that most "gurus" charge for.</p>
          </div>

          <div className="testimonial">
            <blockquote>
              "This tool roasted my listing so hard it needed aloe vera! Worth every second."
              <footer>- Jeff B., Totally Not the Amazon CEO</footer>
            </blockquote>
          </div>
        </div>
      </div>

      <div className="right-panel">
        <div className="form-container">
          <div className="logo-container">
            <img src="/logo-trimmed.png" alt="RoastMyListing Logo" className="form-logo" />
          </div>
          <form
            action="https://app.kit.com/forms/7907195/subscriptions"
            className="seva-form formkit-form"
            method="post"
            data-sv-form="7907195"
            data-uid="6feaf02bd8"
            data-format="inline"
            data-version="5"
            onSubmit={handleSubmit}
            data-options='{&quot;settings&quot;:{&quot;after_subscribe&quot;:{&quot;action&quot;:&quot;message&quot;,&quot;success_message&quot;:&quot;Success! Redirecting you to RoastMyListing...&quot;},&quot;analytics&quot;:{&quot;google&quot;:null,&quot;fathom&quot;:null,&quot;facebook&quot;:null,&quot;segment&quot;:null,&quot;pinterest&quot;:null,&quot;sparkloop&quot;:null,&quot;googletagmanager&quot;:null},&quot;modal&quot;:{&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15},&quot;powered_by&quot;:{&quot;show&quot;:false,&quot;url&quot;:&quot;https://kit.com/features/forms?utm_campaign=poweredby&amp;utm_content=form&amp;utm_medium=referral&amp;utm_source=dynamic&quot;},&quot;recaptcha&quot;:{&quot;enabled&quot;:false},&quot;return_visitor&quot;:{&quot;action&quot;:&quot;hide&quot;,&quot;custom_content&quot;:&quot;&quot;},&quot;slide_in&quot;:{&quot;display_in&quot;:&quot;bottom_right&quot;,&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15},&quot;sticky_bar&quot;:{&quot;display_in&quot;:&quot;top&quot;,&quot;trigger&quot;:&quot;timer&quot;,&quot;scroll_percentage&quot;:null,&quot;timer&quot;:5,&quot;devices&quot;:&quot;all&quot;,&quot;show_once_every&quot;:15}},&quot;version&quot;:&quot;5&quot;}'
            min-width="400 500 600 700 800" 
            style={{backgroundColor: "rgb(249, 250, 251)", borderRadius: "4px"}}
          >
            <div className="formkit-background" style={{opacity: 0.2}}></div>
            <div data-style="minimal" style={{padding: "20px", width: "100%", position: "relative"}}>
              <div 
                    className="formkit-header" 
                    data-element="header" 
                    style={{
                      color: "rgb(77, 77, 77)", 
                      fontSize: "13px", 
                      fontWeight: 700,
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      marginBottom: "20px"
                    }}
                  >
                    <h2>Your Better Amazon Listing Starts Here</h2>
                  </div>
                  <ul className="formkit-alert formkit-alert-error" data-element="errors" data-group="alert"></ul>
                  <div className="formkit-alert formkit-alert-success" data-element="success" data-group="alert" style={{display: 'none'}}></div>
                  <div data-element="fields" data-stacked="true" className="seva-fields formkit-fields">
                    <div className="formkit-field">
                      <input 
                        className="formkit-input" 
                        aria-label="First Name" 
                        name="fields[first_name]" 
                        placeholder="First Name" 
                        type="text" 
                        style={{
                          color: "rgb(0, 0, 0)", 
                          borderColor: "rgb(227, 227, 227)", 
                          borderRadius: "4px", 
                          fontWeight: 400,
                          padding: "12px",
                          fontSize: "15px",
                          marginBottom: "15px"
                        }}
                        required
                      />
                    </div>
                    <div className="formkit-field">
                      <input 
                        className="formkit-input" 
                        name="email_address" 
                        aria-label="Email Address" 
                        placeholder="Email Address" 
                        required 
                        type="email" 
                        style={{
                          color: "rgb(0, 0, 0)", 
                          borderColor: "rgb(227, 227, 227)", 
                          borderRadius: "4px", 
                          fontWeight: 400,
                          padding: "12px",
                          fontSize: "15px",
                          marginBottom: "15px"
                        }}
                      />
                    </div>
                    <button 
                      data-element="submit" 
                      className="formkit-submit formkit-submit" 
                      style={{
                        color: "rgb(255, 255, 255)", 
                        backgroundColor: "rgb(22, 119, 190)", 
                        borderRadius: "4px", 
                        fontWeight: 400,
                        width: "100%",
                        fontSize: "15px",
                        padding: "12px 24px",
                        cursor: "pointer",
                        border: "none",
                        marginBottom: "15px",
                        transition: "background-color 0.2s ease"
                      }}
                    >
                      <div className="formkit-spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <span>ROAST MY LISTING NOW</span>
                    </button>
                  </div>
                  <div 
                    className="formkit-guarantee" 
                    data-element="guarantee" 
                    style={{
                      color: "rgb(77, 77, 77)", 
                      fontSize: "13px", 
                      fontWeight: 400,
                      textAlign: "center",
                      margin: "10px 0 15px 0"
                    }}
                  >
                    <p>We hate spam more than we hate keyword-stuffed listings. Your info is safe with us.</p>
                  </div>
                </div>
          </form>
        </div>
      </div>
    </div>
  );
};
